import {
  INITIAL_COLUMNS_STATE,
  INITIAL_AD_STATE,
  INITIAL_COLUMNS_STATE_ADS,
} from "./Toolbar/utils";

export const campaignManagerStoreSlice = (set, get) => ({
  selectedCampaign: null,
  setSelectedCampaign: (campaign) =>
    set(() => ({ selectedCampaign: campaign })),
  clearSelectedCampaign: () =>
    set(() => ({
      selectedCampaign: null,
      adsEditedRows: {},
      adsSelectionModel: [],
      adsTableRows: [],
    })),

  campaignManagerSearch: [],
  campaignManagerColumns: INITIAL_COLUMNS_STATE,
  campaignManagerSelectedCategory: null,
  campaignManagerSelectedBrand: [],
  campaignManagerPaginationModel: {
    page: 0,
    pageSize: 25,
  },
  campaignManagerSelectedAdState: null,
  campaignManagerSelectionModel: [],
  campaignManagerRangeDate: null,
  campaignManagerSelectedTimeRange: null,
  campaignManagerSelectedCategoryPath: [],
  campaignManagerAdState: INITIAL_AD_STATE,
  campaignManagerSelectedAdStates: [
    "NPI",
    "Early Stage",
    "High Growth",
    "Profitable core",
    "Exit",
  ],
  campaignAutomationShow: false,
  cmPublishOpen: false,
  setCmPublishOpen: (value) => set(() => ({ cmPublishOpen: value })),
  cmEditedRows: {},
  cmValidationErrors: null,
  campaignManagerRows: [],
  setCampaignManagerRows: (rows) => set(() => ({ campaignManagerRows: rows })),

  // Ads selection
  adsTableRows: [],
  setAdsTableRows: (rows) => set(() => ({ adsTableRows: rows })),
  adsSelectionModel: [],
  setAdsSelectionModel: (selection) =>
    set(() => ({ adsSelectionModel: selection })),
  adsEditedRows: {},
  toggleAdsEditedRow: (rowId, rowData) =>
    set((state) => {
      const isEdited = !!state.adsEditedRows[rowId];
      if (isEdited) {
        const { [rowId]: _, ...rest } = state.adsEditedRows;
        return { adsEditedRows: rest };
      }
      return { adsEditedRows: { ...state.adsEditedRows, [rowId]: rowData } };
    }),
  clearAdsEditedRows: () =>
    set(() => ({ adsEditedRows: {}, adsSelectionModel: [] })),
  setAllAdsEditedRows: (newEditedRows) =>
    set(() => ({
      adsEditedRows: newEditedRows,
      adsSelectionModel: Object.keys(newEditedRows),
    })),

  toggleAdsSelection: (itemId) =>
    set((state) => {
      const current = state.adsSelectionModel;
      if (current.includes(itemId)) {
        return { adsSelectionModel: current.filter((id) => id !== itemId) };
      }
      return { adsSelectionModel: [...current, itemId] };
    }),

  editAdsActive: (row) =>
    set((state) => {
      const existing = state.adsEditedRows[row.itemId];
      const valueOriginal = existing?.active?.valueOriginal ?? row.active;
      const currentValue = existing?.active?.value ?? row.active;
      const newValue = !currentValue;

      const currentSelection = state.adsSelectionModel;
      const newSelection = currentSelection.includes(row.itemId)
        ? currentSelection
        : [...currentSelection, row.itemId];

      if (newValue === valueOriginal && !existing?._deleted) {
        const { [row.itemId]: _removed, ...restRows } = state.adsEditedRows;
        return {
          adsEditedRows: restRows,
          adsSelectionModel: newSelection.filter((id) => id !== row.itemId),
        };
      }

      return {
        adsEditedRows: {
          ...state.adsEditedRows,
          [row.itemId]: {
            ...row,
            ...existing,
            active: { valueOriginal, valueEdited: newValue, value: newValue },
          },
        },
        adsSelectionModel: newSelection,
      };
    }),

  markAdsDeleted: (row) =>
    set((state) => {
      const existing = state.adsEditedRows[row.itemId];
      const currentSelection = state.adsSelectionModel;
      const newSelection = currentSelection.includes(row.itemId)
        ? currentSelection
        : [...currentSelection, row.itemId];

      return {
        adsEditedRows: {
          ...state.adsEditedRows,
          [row.itemId]: { ...row, ...existing, _deleted: true },
        },
        adsSelectionModel: newSelection,
      };
    }),

  unmarkAdsDeleted: (rowId) =>
    set((state) => {
      const existing = state.adsEditedRows[rowId];
      if (!existing) return state;
      const { _deleted, ...rest } = existing;

      const hasActiveChange =
        rest.active !== undefined &&
        rest.active.valueOriginal !== rest.active.valueEdited;

      if (!hasActiveChange) {
        const { [rowId]: _removed, ...restRows } = state.adsEditedRows;
        return {
          adsEditedRows: restRows,
          adsSelectionModel: state.adsSelectionModel.filter(
            (id) => id !== rowId,
          ),
        };
      }
      return {
        adsEditedRows: { ...state.adsEditedRows, [rowId]: rest },
      };
    }),

  //Edited Rows
  toggleCmEditedRow: (rowId, rowData) =>
    set((state) => {
      const isEdited = !!state.cmEditedRows[rowId];
      if (isEdited) {
        const { [rowId]: _, ...rest } = state.cmEditedRows;
        return { cmEditedRows: rest };
      } else {
        return {
          cmEditedRows: {
            ...state.cmEditedRows,
            [rowId]: rowData,
          },
        };
      }
    }),
  clearCmEditedRows: () => set(() => ({ cmEditedRows: {} })),

  importCmChanges: (changes, rows) => {
    const state = get();
    const newEditedRows = { ...state.cmEditedRows };
    const newSelection = [...state.campaignManagerSelectionModel];
    let appliedCount = 0;

    changes.forEach(({ id, campaignName, dailyBudget, targetRoas }) => {
      // Match por id primero, fallback por campaignName
      const row =
        (id != null ? rows.find((r) => String(r.id) === String(id)) : null) ??
        (campaignName
          ? rows.find((r) => r.campaignName === campaignName)
          : null);

      if (!row) return;

      const existing = newEditedRows[row.id] ?? {};

      const budgetChanged =
        dailyBudget !== null &&
        !isNaN(dailyBudget) &&
        Number(dailyBudget) !== Number(row.dailyBudget);

      const roasChanged =
        targetRoas !== null &&
        !isNaN(targetRoas) &&
        Number(targetRoas) !== Number(row.targetRoas);

      if (!budgetChanged && !roasChanged) return;

      newEditedRows[row.id] = {
        ...row,
        ...existing,
        ...(budgetChanged && {
          dailyBudget: {
            valueOriginal:
              existing?.dailyBudget?.valueOriginal ?? row.dailyBudget,
            valueEdited: dailyBudget,
            value: dailyBudget,
          },
        }),
        ...(roasChanged && {
          targetRoas: {
            valueOriginal:
              existing?.targetRoas?.valueOriginal ?? row.targetRoas,
            valueEdited: targetRoas,
            value: targetRoas,
          },
        }),
      };

      if (!newSelection.includes(row.id)) newSelection.push(row.id);
      appliedCount++;
    });

    set({
      cmEditedRows: newEditedRows,
      campaignManagerSelectionModel: newSelection,
    });
    return appliedCount;
  },

  setAllCmEditedRows: (newEditedRows) =>
    set((state) => {
      if (Object.keys(newEditedRows).length === 0) {
        return {
          cmEditedRows: newEditedRows,
          cmValidationErrors: {},
          campaignManagerSelectionModel: [],
        };
      }
      const newRowIds = Object.keys(newEditedRows);
      const newValidationErrors = Object.fromEntries(
        Object.entries(state.cmValidationErrors ?? {}).filter(([key]) =>
          newRowIds.some((rowId) => key.startsWith(`${rowId}-`)),
        ),
      );
      return {
        cmEditedRows: newEditedRows,
        cmValidationErrors: newValidationErrors,
        campaignManagerSelectionModel: newRowIds,
      };
    }),

  // Filtro de Automation
  toggleCampaignAutomationShow: () =>
    set((state) => ({ campaignAutomationShow: !state.campaignAutomationShow })),

  // Filtro de Ad State
  setCampaignManagerSelectedAdState: (adState) =>
    set(() => ({ campaignManagerSelectedAdState: adState })),
  toggleCampaignManagerSelectedAdState: (adState) =>
    set((state) => {
      const selectedAdStates = state.campaignManagerSelectedAdStates || [];
      if (selectedAdStates.includes(adState)) {
        return {
          campaignManagerSelectedAdStates: selectedAdStates.filter(
            (state) => state !== adState,
          ),
        };
      } else {
        return {
          campaignManagerSelectedAdStates: [...selectedAdStates, adState],
        };
      }
    }),
  clearCampaignManagerSelectedAdState: () =>
    set(() => ({ campaignManagerSelectedAdState: null })),

  // Filtro de Category path
  toggleCampaignManagerSelectedCategoryPath: (path) =>
    set((state) => {
      const selected = state.campaignManagerSelectedCategoryPath;
      if (selected.includes(path)) {
        return {
          campaignManagerSelectedCategoryPath: selected.filter(
            (p) => p !== path,
          ),
        };
      }
      return {
        campaignManagerSelectedCategoryPath: [...selected, path],
      };
    }),
  clearCampaignManagerSelectedCategoryPath: () =>
    set(() => ({ campaignManagerSelectedCategoryPath: [] })),

  // Filtro de Fecha
  setCampaignManagerRangeDate: (date) =>
    set(() => ({ campaignManagerRangeDate: date })),
  setCampaignManagerSelectedTimeRange: (timeRange) =>
    set(() => ({ campaignManagerSelectedTimeRange: timeRange })),
  setCampaignSelectedTimeRange: (timeRange) =>
    set(() => ({ campaignManagerSelectedTimeRange: timeRange })),
  clearCampaignManagerRangeDate: () =>
    set(() => ({ campaignManagerRangeDate: null })),
  clearCampaignManagerSelectedTimeRange: () =>
    set(() => ({ campaignManagerSelectedTimeRange: null })),

  // Filtro de Búsqueda
  setCampaignManagerSearch: (search) =>
    set(() => ({ campaignManagerSearch: search })),

  // Filtro de Marca
  setCampaignManagerSelectedBrand: (brand) =>
    set({ campaignManagerSelectedBrand: brand }),

  clearCampaignManagerSelectedBrand: () =>
    set(() => ({
      campaignManagerSelectedBrand: [],
    })),

  // Filtro de Categoría
  setCampaignManagerSelectedCategory: (selectedCategory) =>
    set(() => ({ campaignManagerSelectedCategory: selectedCategory })),
  clearCampaignManagerSelectedCategory: () =>
    set(() => ({ campaignManagerSelectedCategory: null })),

  // Paginación Campañas
  setCampaignManagerPaginationModel: (modelOrUpdater) =>
    set((state) => ({
      campaignManagerPaginationModel:
        typeof modelOrUpdater === "function"
          ? modelOrUpdater(state.campaignManagerPaginationModel)
          : modelOrUpdater,
    })),
  setCampaignManagerSelectionModel: (selection) =>
    set(() => ({ campaignManagerSelectionModel: selection })),

  // Paginación Ads
  adsTablePaginationModel: { page: 0, pageSize: 25 },
  setAdsTablePaginationModel: (modelOrUpdater) =>
    set((state) => ({
      adsTablePaginationModel:
        typeof modelOrUpdater === "function"
          ? modelOrUpdater(state.adsTablePaginationModel)
          : modelOrUpdater,
    })),

  // Edición de campos
  editCmField: (row, field, newValue) =>
    set((state) => {
      const existingEditedRow = state.cmEditedRows[row.id];
      const existingField = existingEditedRow?.[field];
      const valueOriginal =
        existingField?.valueOriginal !== undefined
          ? existingField.valueOriginal
          : row[field];

      const currentSelection = state.campaignManagerSelectionModel;
      const newSelection = currentSelection.includes(row.id)
        ? currentSelection
        : [...currentSelection, row.id];

      return {
        cmEditedRows: {
          ...state.cmEditedRows,
          [row.id]: {
            ...row,
            ...existingEditedRow,
            [field]: {
              valueOriginal,
              valueEdited: newValue,
              value: newValue,
            },
          },
        },
        campaignManagerSelectionModel: newSelection,
      };
    }),

  clearCmFieldEdit: (rowId, field, originalRow) =>
    set((state) => {
      const existingEditedRow = state.cmEditedRows[rowId];
      if (!existingEditedRow) return state;

      const existingField = existingEditedRow[field];
      const originalValue =
        existingField?.valueOriginal !== undefined
          ? existingField.valueOriginal
          : originalRow[field];

      const updatedRow = {
        ...existingEditedRow,
        [field]: {
          valueOriginal: originalValue,
          valueEdited: originalValue,
          value: originalValue,
        },
      };

      const editableFields = ["dailyBudget", "targetRoas"];
      const hasChanges = editableFields.some((key) => {
        const fieldData = updatedRow[key];
        if (
          fieldData?.valueOriginal !== undefined &&
          fieldData?.valueEdited !== undefined
        ) {
          return fieldData.valueOriginal !== fieldData.valueEdited;
        }
        return false;
      });

      if (!hasChanges) {
        const newEditedRows = { ...state.cmEditedRows };
        delete newEditedRows[rowId];
        return { cmEditedRows: newEditedRows };
      }

      return {
        cmEditedRows: {
          ...state.cmEditedRows,
          [rowId]: updatedRow,
        },
      };
    }),

  setCmValidationError: (rowId, field, errorMessage) =>
    set((state) => ({
      cmValidationErrors: {
        ...(state.cmValidationErrors ?? {}),
        [`${rowId}-${field}`]: errorMessage,
      },
    })),

  clearCmValidationError: (rowId, field) =>
    set((state) => {
      const newErrors = { ...(state.cmValidationErrors ?? {}) };
      delete newErrors[`${rowId}-${field}`];
      return { cmValidationErrors: newErrors };
    }),

  // Filtros Generales
  CampaignManagerClearFilters: () =>
    set(() => ({
      campaignManagerSearch: [],
      campaignManagerSelectedBrand: [],
      campaignManagerPaginationModel: {
        page: 0,
        pageSize: 25,
      },
    })),

  // Columnas campañas
  toggleCampaignManagerColumns: (field, value) =>
    set((state) => ({
      campaignManagerColumns: {
        ...state.campaignManagerColumns,
        [field]: value,
      },
    })),
  resetCampaignManagerColumns: () =>
    set(() => ({
      campaignManagerColumns: INITIAL_COLUMNS_STATE,
    })),

  // Columnas ads
  campaignManagerColumnsAds: INITIAL_COLUMNS_STATE_ADS,
  toggleCampaignManagerColumnsAds: (field, value) =>
    set((state) => ({
      campaignManagerColumnsAds: {
        ...state.campaignManagerColumnsAds,
        [field]: value,
      },
    })),
  resetCampaignManagerColumnsAds: () =>
    set(() => ({
      campaignManagerColumnsAds: INITIAL_COLUMNS_STATE_ADS,
    })),
});
